import { Translation, useTranslation } from "react-i18next";
import { TerminalTypesInfo } from "../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalTypesCall"
export interface Pen {
  id: string;
  penId: string | null;
  name?: string;
  visual?: string;
  io: number | null;
  feederOutput?: number | null;
  waterOutput?: number | null;
  activatorInput?: number | null;
  feederOutputConfig?: Omit<TerminalTypesInfo & {"p_sensor"?: number}, "input">;
  waterOutputConfig?: TerminalTypesInfo & {"p_sensor"?: number};
  activatorInputConfig?: TerminalTypesInfo & {"p_sensor"?: number};
  blockedIos?: {feederOutput: boolean, waterOutput?: boolean, activatorInput?: boolean};
}

export interface Station {
  id: string;
  stationId: string | null;
  name?: string;
  visual?: string;
  // io: number | null;
  reader: number | null;
  readerInput?: number | null;
  // feederOutput?: number | null;
  // feederInput?: number | null;
  // gateMotorOutput?: number | null;
  // gateMotorInput?: number | null;
  // gateSensor?: number | null;
  // waterOutput?: number | null;
  // buttonInput?: number | null;

  // feederOutputConfig?: Omit<TerminalTypesInfo & {"p_sensor"?: number}, "input">;
  // waterOutputConfig?: TerminalTypesInfo & {"p_sensor"?: number};
  // gateMotorOutputConfig?: TerminalTypesInfo & {"p_sensor"?: number};
  // gateSensorConfig?: TerminalTypesInfo & {"p_sensor"?: number};
  // buttonInputConfig?: TerminalTypesInfo & {"p_sensor"?: number};
  readerInputConfig?: TerminalTypesInfo & { "sensor_p"?: number };
  
  terminals: StationTerminalRecord;
}

export interface StationTerminal {
  __terminalType: "readerInput" | "feederOutput" | "feederInput" | "gateMotorOutput" | "gateMotorInput" | "gateSensor" | "waterOutput" | "buttonInput";
  io?: number | null;
  port?: number | null;
  terminalType?: number | null;
  terminalConfig?: TerminalTypesInfo & { "sensor_p"?: number } | null;
  terminalOrder?: number | null;
}

type StationTerminalRecord = Record<(StationTerminal["__terminalType"] | string), StationTerminal>

export interface Section {
  lanController: string;
  contents: Pen[] | Station[];
  feeder?: number;
  water?: boolean;
  activator?: boolean;
  gate?: boolean;
  button?: boolean;
  columns: number;
  rows: number;
  name: string;
  startNumber?: number;
  numbering?: NumberingOptions;
  startCorner?: StartCornerOptions;
  direction?: DirectionOptions;
  pattern?: PatternOptions;
  firstColVisuals?: number;
  secondColVisuals?: number;
}

/* eslint-disable */
export enum NumberingOptions {
  manual = "manual",
  automatic = "automatic"
}
/* eslint-enable */

/* eslint-disable */
export enum StartCornerOptions {
  topLeft = "topLeft",
  topRight = "topRight",
  bottomLeft = "bottomLeft",
  bottomRight = "bottomRight"
}
/* eslint-enable */

/* eslint-disable */
export enum DirectionOptions {
  horizontal = "horizontal",
  vertical = "vertical"
}
/* eslint-enable */

/* eslint-disable */
export enum PatternOptions {
  z = "Z",
  u = "U"
}
/* eslint-enable */

export const useOptionTranslate = () => {
  const { t } = useTranslation()

  const translateOptions = <T extends object>(enumObj: T) =>
    Object.values(enumObj).map((label, index) => ({
      id: index,
      label: t(`devices.${label}`, { defaultValue: label }),
      value: label
    }))

  return {
    numberingOptions: translateOptions(NumberingOptions),
    startCornerOptions: translateOptions(StartCornerOptions),
    directionOptions: translateOptions(DirectionOptions),
    patternOptions: translateOptions(PatternOptions),
  }
}